<template>
  <div>
    <material-card
      text="Master Payer Account List"
      color="orange"
      title="Account Inventory">
      <v-layout
        class="account-filters"
        justify-center
        wrap>
        <v-flex md2>
          <v-text-field
            v-model="search"
            label="Search"
            single-line
            hide-details
            append-icon="search"
          />
        </v-flex>
        <v-flex
          sm4
          md2 >
          <v-select
            v-model="selectedAcctStatus"
            :items="acctStatusFilter"
            item-text="text"
            item-value="value"
            attach
            chips
            label="Filter By Account Status"
            multiple
            solo
          />
        </v-flex>
        <Can
          I="manage"
          a="reports">
          <v-flex style="text-align: right">
            <HelperCsvDownload
              :data="filteredAccounts"
              :getData="getFilteredAccounts"
              :title="'Attestation-Report'"
              @csv-download-success="downloadFinished"/>
          </v-flex>
        </Can>
      </v-layout>
      <v-layout
        v-show="selected.length > 0"
        align-end
        justify-end
        row
        fill-height
        class="mass-update-actions"
        transition="fade-transition">
        <v-flex
          md4
          align-self-center>
          <p class="subtitle-1 mb-0"><span class="font-weight-black">({{ selected.length }})</span> accounts selected</p>
        </v-flex>
        <v-flex
          md8
          style="text-align: right">
          <v-btn
            v-if="deletedFilter == '1'"
            small
            class="mr-2"
            color="orange"
            @click="unArchiveAccount(selected)" ><v-icon left>reply</v-icon>Restore Accounts</v-btn>
          <Can
            I="manage"
            a="admin">
            <v-btn
              small
              class="mr-2"
              color="orange"
              @click="updateLastDateValidated = true" >Update Last Validated</v-btn>
          </Can>
        </v-flex>
      </v-layout>
      <v-data-table
        ref="accountList"
        :headers="getAccountHeaders"
        :items="filteredAccounts"
        :search="search"
        :pagination.sync="pagination"
        v-model="selected"
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        select-all
        item-key="Acct_ID"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" >
            <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              />
            </td>
            <td>{{ props.item.OppReg_Id }}</td>
            <td>{{ props.item.Opportunity_Number }}</td>
            <td>{{ props.item.Acct_name }}</td>
            <td>{{ props.item.Acct_Status }}</td>
            <td>{{ props.item.Acct_Offering_Stat }}</td>
            <td>{{ props.item.Acct_DL }}</td>
            <td>{{ props.item.Acct_ID }}</td>
            <td>{{ props.item.Date_onboarded }}</td>
            <td>{{ props.item.Last_Date_Validated }}</td>
            <td>{{ props.item.MP_ID }}</td>
            <td>
              <div v-if="props.item.DateMarkedAsUnknown !== 'None' && props.item.MP_Name.includes('UNKNOWN')">
                <v-chip
                  color="orange"
                  text-color="white">
                  <span v-html="daysMarkedAsUnknown(props.item.DateMarkedAsUnknown)"/>
                </v-chip>
              </div>
              <div v-else>
                None
              </div>
            </td>
            <td>{{ props.item.Previous_MP_ID }}</td>
            <td>{{ props.item.Customer_Name }}</td>
            <td>{{ props.item.Customer_Alias_Group }}</td>
            <td>{{ props.item.Managed_Svc }}</td>
            <td>{{ props.item.AWS_Support_Type }}</td>
            <td>{{ props.item.Customer_Region }}</td>
            <td>{{ props.item.Acct_Restricted }}</td>
            <td>{{ props.item.MFA }}</td>
            <td>{{ props.item.Root_Credential_Store }}</td>
            <td>{{ props.item.DXC_discount }}</td>
            <td>{{ props.item.Client_discount }}</td>
            <td>{{ props.item.MP_uplift }}</td>
            <td>{{ props.item.Client_uplift }}</td>
            <td>{{ props.item.WBS_code }}</td>
            <td>{{ props.item.IWO_Code }}</td>
            <td>{{ props.item.Comments }}</td>

          </tr>
        </template>
      </v-data-table>

    </material-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {

  props: {
    title: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    },
    type: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    }
  },
  data: () => ({
    selected: [],
    selectedAcctStatus: ['New', 'ACTIVE'],
    menu2: false,
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    agreementFilter: 'all',
    archivedAcctStatus: null,
    groupAliasFilter: []
  }),
  computed: {
    ...mapState('admin/accountInventory', ['masterAccounts', 'pods', 'accountHeaders', 'acctStatusFilter', 'acctMiscFilter', 'lastDateValidatedStatus']),
    ...mapState('admin', ['customers']),
    ...mapGetters({
      getAccountHeaders: 'admin/accountInventory/getAccountHeaders'
    }),
    filteredAccounts () {
      // let customerAliasGroup = this.groupAliasFilter === 0 ||this.groupAliasFilter === '' || this.groupAliasFilter === undefined ? 'None' : this.groupAliasFilter
      let customerAliasGroup = this.groupAliasFilter === 0 ||this.groupAliasFilter === '' || this.groupAliasFilter === undefined ? 'None' : this.groupAliasFilter

      if (this.type === 'byAwsAgreement') {
        switch (this.agreementFilter) {
          case 'restricted':
            return this.masterAccounts.filter(account => account.Acct_Restricted == 'Yes')
          case 'UNKNOWN':
            return this.masterAccounts.filter(account => account.MP_Name.includes('UNKNOWN'))
          case 'gold':
            let golds = ['DXC Gold', 'Internal Gold', 'Commercial Gold']
            return this.masterAccounts.filter(account => golds.includes(account.Managed_Svc))
          case 'all':
            return this.masterAccounts.filter(account => (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted  && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
          case 'sp':
            return this.masterAccounts.filter(account => account.agreement.indexOf('spp -') !== -1 && (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
          case 'spp':
          case 'ppa':
            return this.masterAccounts.filter(account => account.agreement === this.agreementFilter && (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
          case 'other':
            return this.masterAccounts.filter(account => (!['sp', 'spp', 'ppa'].includes(account.agreement) && account.agreement.indexOf('spp -') === -1) && (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
          default:
            break
        }
      } else if (this.type === 'byMasterPayer') {
        return this.masterAccounts.filter(account => account.Master_Id == this.$route.params.id && (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
      } else if (this.type === 'byCustomer') {
        return this.masterAccounts.filter(account => account.Customer_Name == this.$route.params.id && (this.selectedAcctStatus.includes(account.Acct_Status) || !this.selectedAcctStatus.length) && account.Del_Flag == viewDeleted && (this.groupAliasFilter.includes(account.Customer_Alias_Group) || !this.groupAliasFilter.length))
      }
    }
  },
  methods: {
    getFilteredAccounts () {
      this.pagination.rowsPerPage = -1
      let data = this.$refs.accountList.filteredItems
      this.pagination.rowsPerPage = 10
      return data
    },
    downloadFinished () {
      console.log('download finished')
      this.pagination.rowsPerPage = 10
    },
    editItem (item) {
      this.$store.commit('admin/openAccountDialog', {
        show: true,
        type: 'edit',
        showSelectCustomer: false,
        fields: { ...item },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Update',
        submitHandler: () => {
          this.$store.dispatch('admin/updateAccount')
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Acct_ID, changeFrom: { ...item } }, { root: true })
    },
    flagAccount (data) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/accountInventory/delete', data)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: 'Do you want to delete this Account ID:' + data,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    cloneAccount (item) {
      this.$store.commit('admin/openClonedAccount', {
        show: true,
        type: 'new',
        showSelectCustomer: false,
        fields: { ...item, Acct_ID: null },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Create',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewAccount', fields)
        }
      })
    },
    updateLastDateValidatedField () {
      let selectedAccount = {
        updatedLastDateValidated: this.lastDateVal,
        selected: this.selected
      }
      this.$store.dispatch('admin/accountInventory/updateFieldLastDateValidated', selectedAccount)
    },
    onShowLogs (account) {
      this.$store.dispatch('showLogRecords', account.Acct_ID)
    },
    unArchiveAccount (account) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/accountInventory/unArchive', account)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: Array.isArray(account) ? 'Do you want to restore the selected accounts:' : 'Do you want to restore this Account ID: ' + account.Acct_ID,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    viewAcctStatus () {
      let viewAccountStatus = this.archivedAcctStatus
      if (viewAccountStatus === '1') {
        this.selectedAcctStatus = ['Suspended', 'Moved to Client']
      } else {
        this.selectedAcctStatus = ['Active', 'New']
      }
    },
    checkFieldPerm () {
      this.blurConfig.isBlurred = this.$store.state.viewCustomFields.isAllowed
      return true
    },
    daysMarkedAsUnknown (item) {
      let currentDate = new Date()
      let markedDate = new Date(item)
      let cDate = currentDate.valueOf()
      let mDate = markedDate.valueOf()

      let since_days = (cDate - mDate) / 1000 / 86400
      since_days = Math.round(since_days - 0.5)
      return since_days + (since_days > 1 ? ' Days ago.' : ' Day ago.')
    }
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}

.masterDropdown {
  margin-bottom: 0;
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
    color: #fff !important;
  }
  .theme--light.v-select .v-select__selections {
    color: #fff !important;
  }
  .theme--light.v-icon {
    color: #fff;
  }
}
.v-progress-linear {
      margin: 0;
      bottom: -15px;
  }

.mass-update-actions {
  background: rgba(65, 179, 223, 0.3);
}
</style>
